import { useQuery } from '@tanstack/react-query';
import type { PrintableDocument } from '@optiflow/types';
import { api } from '@/services/apiClient';

/** One read per document. A print page that fetches four times prints half a receipt. */
export function usePrintableQuery(kind: 'receipt' | 'invoice', id: string | undefined) {
  return useQuery({
    queryKey: ['sales', 'print', kind, id ?? ''],
    queryFn: () => api.get<PrintableDocument>(`/sales/print/${kind}/${id ?? ''}`),
    enabled: Boolean(id),
    // A document is printed once; refetching it mid-print would be worse than useless.
    staleTime: Infinity,
    retry: false,
  });
}
